import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Trophy, Users } from 'lucide-react';

interface TeamLeaderboardEntry {
  rank: number;
  teamName: string;
  player1Name: string;
  player2Name: string;
  totalPoints: number;
  gamesPlayed: number;
}

interface TeamAmericanoLeaderboardProps {
  teams: TeamLeaderboardEntry[];
}

export function TeamAmericanoLeaderboard({ teams }: TeamAmericanoLeaderboardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="h-5 w-5" />
          Team Leaderboard
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-16">Rank</TableHead>
              <TableHead>Team</TableHead>
              <TableHead className="text-center">Points</TableHead>
              <TableHead className="text-center">Games</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {teams.map((team) => (
              <TableRow key={team.teamName}>
                <TableCell>
                  {team.rank === 1 && <Trophy className="h-4 w-4 inline mr-1 text-yellow-500" />}
                  <span className="font-semibold">{team.rank}</span>
                </TableCell>
                <TableCell>
                  <div className="flex items-start gap-2">
                    <Badge variant="outline">{team.teamName}</Badge>
                    <div className="flex flex-col">
                      <span className="text-sm">{team.player1Name}</span>
                      <span className="text-sm">{team.player2Name}</span>
                    </div>
                  </div>
                </TableCell>
                <TableCell className="text-center font-semibold">
                  {team.totalPoints}
                </TableCell>
                <TableCell className="text-center">
                  {team.gamesPlayed}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        {teams.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            <Users className="h-12 w-12 mx-auto mb-2 opacity-50" />
            <p>No teams available</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
